import React from 'react';
export function acidForwardRef(render) {
    // @ts-ignore
    return React.forwardRef(render);
}
//# sourceMappingURL=forwardRef.js.map